import { render, staticRenderFns } from "./cdn-logo-by-lang.vue?vue&type=template&id=0df6942a&"
import script from "./cdn-logo-by-lang.vue?vue&type=script&lang=js&"
export * from "./cdn-logo-by-lang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports